import { JSX } from 'react';
import addButton from '../../assets/images/peppermint-butler.png';
import todoButton from '../../assets/images/finn.png';
import noteButton from '../../assets/images/lsp.png';
import calendarButton from '../../assets/images/icons/gunter.png';
import Button from './button'; // Make sure filename matches case
import './menu.css'
import { HomepageProps, homePageButton } from '../homePage';


const Menu = ({clickButton, onClickButtonChange}:HomepageProps): JSX.Element => {
  const ButtonClick = (button:homePageButton) => {
    if (button === clickButton) {
      onClickButtonChange(null);
    }
    else {
      onClickButtonChange(button);
    }
  }

  return (
    <div className='menu-container'>
      <Button image={addButton} title='Add' onClick={()=>ButtonClick('Add')}/>
      <Button image={todoButton} title='Todo'  onClick={()=>ButtonClick('Todo')}/>
      <Button image={noteButton} title='Note' onClick={()=>ButtonClick('Note')}/>
      <Button image={calendarButton} title='Calendar' onClick={()=>ButtonClick('Calendar')}/>
    </div>
  ); 
};

export default Menu;